(() => {
  if (customElements.get('bt-cart-meter')) return;
  const history = new Map();
  class BartisansCartMeter extends HTMLElement {
    connectedCallback() {
      this.effects = [];
      this.timers = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => { if (this.motion.matches) this.stop(); };
      this.motion.addEventListener('change', this.onMotion);
      this.drawer = this.closest('cart-drawer');
      this.drawerObserver = new MutationObserver(() => {
        if (this.drawer.hasAttribute('open')) {
          this.frame = requestAnimationFrame(() => {
            if (this.isVisible() && !this.visible) { this.play(); this.visible = true; }
          });
        } else { this.visible = false; }
      });
      if (this.drawer) this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          const visible = entry.isIntersecting && this.isVisible();
          if (visible && !this.visible) this.play();
          this.visible = visible;
        }
      }, { threshold: 0.25 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.drawerObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.motion?.removeEventListener('change', this.onMotion);
      this.stop();
    }
    isVisible() {
      if (this.drawer && !this.drawer.hasAttribute('open')) return false;
      return !this.checkVisibility || this.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    }
    stop() {
      this.effects?.forEach(effect => effect.cancel());
      this.timers?.forEach(timer => clearTimeout(timer));
      this.effects = [];
      this.timers = [];
    }
    animate(node, frames, options) {
      if (node && !this.motion.matches) this.effects.push(node.animate(frames, options));
    }
    play() {
      this.stop();
      const key = this.dataset.context + ':' + this.dataset.key;
      const target = Math.max(0, Math.min(1, Number(this.dataset.progress) || 0));
      const previous = history.get(key);
      const start = previous && previous.progress !== target ? previous.progress : 0;
      const milestones = [...this.querySelectorAll('[data-reward]')];
      const unlocked = milestones.filter(item => item.dataset.unlocked === 'true').map(item => item.dataset.reward);
      history.set(key, { progress: target, unlocked });
      if (this.motion.matches) return;
      const duration = 850;
      this.animate(this.querySelector('.btm__fill'), [{ transform: `scaleX(${start})` }, { transform: `scaleX(${target})` }], { duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' });
      this.animate(this.querySelector('.btm__cursor'), [{ left: `${start * 100}%` }, { left: `${target * 100}%` }], { duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' });
      for (const item of milestones) {
        if (item.dataset.unlocked !== 'true' || previous?.unlocked.includes(item.dataset.reward)) continue;
        const position = Number(item.dataset.position);
        const fraction = target > start ? Math.max(0, Math.min(1, (position - start) / (target - start))) : 0;
        const timer = setTimeout(() => this.celebrate(item), Math.round(fraction * duration));
        this.timers.push(timer);
      }
    }
    celebrate(item) {
      if (!this.isConnected || this.motion.matches) return;
      this.animate(item.querySelector('.btm__mark'), [{ transform: 'translateY(0) scale(1)', boxShadow: '0 0 0 0 #b8733360' }, { transform: 'translateY(-5px) scale(1.14)', boxShadow: '0 0 0 8px #b8733300', offset: 0.45 }, { transform: 'translateY(0) scale(1)', boxShadow: '0 0 0 12px #b8733300' }], { duration: 650, easing: 'ease-out' });
      if (item.dataset.reward !== 'gift') return;
      this.animate(item.querySelector('.btm__gift-lid'), [{ transform: 'translateY(0) rotate(0)' }, { transform: 'translateY(-4px) rotate(-12deg)', offset: 0.35 }, { transform: 'translateY(-3px) rotate(10deg)', offset: 0.65 }, { transform: 'translateY(0) rotate(0)' }], { duration: 700, easing: 'ease-in-out' });
      this.querySelectorAll('.btm__confetti i').forEach((piece, index) => {
        const drift = (index % 2 ? 1 : -1) * (12 + index * 2);
        this.animate(piece, [{ opacity: 0, transform: 'translate(0,-6px) rotate(0)' }, { opacity: 1, offset: 0.15 }, { opacity: 0, transform: `translate(${drift}px,65px) rotate(${150 + index * 23}deg)` }], { duration: 950, delay: index * 22, easing: 'ease-out' });
      });
    }
  }
  customElements.define('bt-cart-meter', BartisansCartMeter);
})();
